<template>
    <!-- Tab container -->
    <div ref="tabPane" class="tab-pane fade" :class="tabIndex == 0 ? 'active show' : ''" :id="`tab-${tabIndex}-pane-${sizeClass}`" role="tabpanel" :tabindex="tabIndex">
        <!-- Search item container -->
        <div class="search-item cursor-pointer d-flex align-items-center gap-3 py-2" v-for="(data, index) in tabData" v-load-page="'/' + data.tabType + '/' + data.slug" v-ripple>
            <!-- Item image -->
            <img class="rounded avatar" :src="randomImages[Math.floor(Math.random() * randomImages.length)]">
            <!-- Item name and description -->
            <div class="d-flex flex-column gap-1">
                <p class="lh-1 m-0 text-body">{{ data.name }}</p>
                <p class="caption m-0 lh-1 text-gray-600 text-capitalize" v-if="props.tabKey == 'all' && data.tabType">{{ helper.toSingular(data.tabType.replace('_', ' ')) }}</p>
            </div>
            <!-- Item rating -->
            <div class="ms-auto fw-bold m-0" v-if="data.dataExtraKey">
                <span v-for="stat in data.dataExtraKey" class="d-flex gap-1 align-items-center">
                    <i v-if="stat.iconType == 'bootstrap'" class="bi inline-icon" :class="stat.icon + ' ' + stat.iconColor"></i>
                    <font-awesome-icon v-else-if="stat.iconType == 'fontawesome'" :icon="stat.icon" :class="stat.iconColor" />
                    <span class="d-flex" style="font-size: 18px;">{{ data[stat.key] }}</span>
                </span>
            </div>
        </div>

        <div ref="infiniteLoaderContainer" class="d-none infinite-loader-container"></div>
    </div>
</template>

<script setup>
import { onMounted, onUnmounted, ref, watch } from 'vue';
import { useAppHelpers } from '@/composables/useAppHelpers';
import Tab from 'bootstrap/js/dist/tab';
import * as Sentry from '@sentry/vue';

const helper = useAppHelpers();

const props = defineProps({
    sizeClass: String,
    tabIndex: Number,
    tabData: Object,
    tabKey: String,
    loadingData: Boolean,
    allLoaded: Boolean,
    keyword: String,
    activeTab: String
});

const emits = defineEmits(['load-more']);

const infiniteLoaderContainer = ref(null);
const contentLoading = ref(false);
const tabPane = ref(null);
const tabParent = ref(null);

watch(() => props.loadingData, (val) => {
    if (val) {
        contentLoading.value = true;
        helper.loaderOn(infiniteLoaderContainer.value, true);
    }
    else {
        helper.loaderOff(infiniteLoaderContainer.value, true);
        contentLoading.value = false;
    }
});

const infiniteContentLoadHandler = () => {
    if (!props.loadingData && !props.allLoaded && tabParent.value.clientHeight + tabParent.value.scrollTop >= tabParent.value.scrollHeight) {
        if (props.activeTab == props.tabKey) {
            emits('load-more', props.tabKey);
        }

    }
}

onMounted(() => {
    setTimeout(() => {
	    try{
		    tabParent.value = tabPane.value.parentNode;
		    tabParent.value.addEventListener('scroll', infiniteContentLoadHandler)
	    }
	    catch(error){
		    Sentry.captureException(error);
		    Sentry.captureMessage('Error in SearchTab.vue onMounted', {
			    'tabParent': tabParent.value,
		    });
	    }
    }, 500);

});

onUnmounted(() => {
    if (tabParent.value) {
        tabParent.value.removeEventListener('scroll', infiniteContentLoadHandler);
    }

});

const randomImages = [
    'https://images.pexels.com/photos/3689307/pexels-photo-3689307.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    'https://images.pexels.com/photos/13564526/pexels-photo-13564526.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    'https://images.pexels.com/photos/16441669/pexels-photo-16441669/free-photo-of-mode-kvinna-flicka-sot.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    'https://images.pexels.com/photos/12551732/pexels-photo-12551732.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    'https://images.pexels.com/photos/13779107/pexels-photo-13779107.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    'https://images.pexels.com/photos/4092837/pexels-photo-4092837.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    'https://images.pexels.com/photos/9951389/pexels-photo-9951389.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    'https://images.pexels.com/photos/14530635/pexels-photo-14530635.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    'https://images.pexels.com/photos/8460603/pexels-photo-8460603.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    'https://images.pexels.com/photos/16329380/pexels-photo-16329380/free-photo-of-avslappning-glas-lyx-tval.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
    'https://images.pexels.com/photos/13430311/pexels-photo-13430311.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'
]

</script>

<style scoped lang="scss"></style>